import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useLogIn } from "./LoginContext ";
import { AmbikaVenderApi } from "./config";
import { requestForToken } from "../firebase";

const Login = () => {
  const [number, setNumber] = useState("");
  const [otpToggel, setOtpToggel] = useState(false);
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { setIsLogIn } = useLogIn();
  const navigate = useNavigate();

  const maskNumber = (num) => {
    if (!num || num.length < 10) return num;
    const numStr = num.toString();
    const maskedSection = numStr.slice(2, -4).replace(/./g, "*");
    return numStr.slice(0, 2) + maskedSection + numStr.slice(-4);
  };

  const validatePhoneNumber = (phone) => {
    return phone?.length === 10;
  };

  const checkNumber = async () => {
    if (!validatePhoneNumber(number)) {
      Swal.fire({
        text: "Please enter a valid 10-digit mobile number starting with 6-9",
      });
      return;
    }

    setIsLoading(true);
    try {
      const res = await axios.post(`${AmbikaVenderApi}/login`, {
        phone: number,
        roleid: "5",
      });

      if (res?.data?.success) {
        Swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          icon: "success",
          text: res?.data?.message,
        });
        setOtpToggel(true);
      } else {
        Swal.fire({
          text: res?.data?.message || "Failed to send OTP",
        });
      }
    } catch (err) {
      Swal.fire({
        text: "An error occurred. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const chekOtp = () => {
    axios
      .post(`${AmbikaVenderApi}/checkOTP`, {
        phone: number,
        roleid: "5",
        otp: otp,
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            icon: "success",
            text: `${res?.data?.message}`,
          });
          localStorage.setItem("ambikaUserToken", res?.data?.token);
          localStorage.setItem("ambikaUserId", res?.data?.UserId);
          requestForToken(res?.data?.UserId, res?.data?.token);

          navigate("/products");
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
          });
        }
      })
      .catch((err) => { });
  };

  const handleNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setNumber(value);
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setOtp(value);
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ height: "100vh", width: "100%" }}
      >
        <div
          className="col-lg-6 col-md-8 rounded-4 p-4"
          style={{ boxShadow: " rgba(17, 12, 46, 0.15) 0px 48px 100px 0px" }}
        >
          <div className="col-11 m-auto text-start ">
            <img
              src={require("./image/logo.png")}
              style={{ width: "150px" }}
              alt=""
            />
            <p className="fs-1 text-start mt-3">Please Login to Continue</p>
            <div className="form__group field">
              <input
                type="tel"
                maxLength={10}
                className="form__field"
                value={number}
                placeholder="Number"
                name="number"
                id="numberInput"
                onChange={handleNumberChange}
              />
              <label htmlFor="numberInput" className="form__label">
                Enter Your Phone Number
              </label>
            </div>
            <button
              className="btn btn-success form-control rounded-4 mt-4"
              disabled={!validatePhoneNumber(number) || isLoading}
              onClick={checkNumber}
            >
              {isLoading ? "Sending..." : "Continue"}
            </button>
          </div>
        </div>

        {otpToggel && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: "100%",
              height: "100%",
              position: "fixed",
              top: "0",
              left: "0",
            }}
          >
            <div className="col-lg-6 col-md-8 bg-white rounded-4 p-4">
              <div className="col-11 m-auto text-start ">
                <img
                  src={require("./image/logo.png")}
                  style={{ width: "150px" }}
                  alt=""
                />

                <p className="fs-1 text-start mt-3">Verification Code</p>

                <p className="text-secondary">
                  <span>We have sent the code verification to</span>{" "}
                  <span className="fs-5 text-black"> {maskNumber(number)}</span>{" "}
                  <span
                    className="fs-5"
                    style={{
                      color: "green",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => setOtpToggel(false)}
                  >
                    {" "}
                    Change ?{" "}
                  </span>{" "}
                </p>

                <div className="form__group field">
                  <input
                    type="tel"
                    maxLength={6}
                    className="form__field"
                    value={otp}
                    placeholder="OTP"
                    name="otp"
                    id="otpInput"
                    onChange={handleOtpChange}
                  />
                  <label htmlFor="otpInput" className="form__label">
                    OTP
                  </label>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <button
                    className="btn btn-success form-control rounded-4 mt-4"
                    onClick={chekOtp}
                    disabled={!otp || otp.length !== 6 || isLoading}
                  >
                    {isLoading ? "Verifying..." : "Confirm"}
                  </button>
                  <button
                    className="btn btn-outline-success form-control rounded-4 mt-4"
                    onClick={checkNumber}
                    disabled={isLoading}
                  >
                    Resend
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Login;
